var map = {
	"./01.png": 5225,
	"./02.png": 7042,
	"./03.png": 8587,
	"./04.png": 3780,
	"./05.png": 7021,
	"./06.png": 5254,
	"./07.png": 9055,
	"./08.png": 1992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5556;